import { FC, useMemo } from 'react';
import { Dropdown, DropdownListItem, FInter, FlexBox, useBreakpoint } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { SortingTypeIndex } from '../../../constants/sortingType';
import { HoverItemText, HoverItemWithSvg, ProjectSearchBarRoot, SortSmallTextDiv } from '../style';
import styled, { css, useTheme } from 'styled-components';
import { AppTester, getCurrentAppName } from '../../../../supporting';
import { DropdownText } from 'shared/navbars/components/contextTabsItems';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { LayoutConst } from "../../../../core";
import { SortingTypeIndexPeople } from "../../../pages/context/contextViewClear";
import { SortIcon } from 'shared/icons';
import { useRouteMatch } from 'react-router-dom';

const DropDownWrapper = styled(FlexBox) <{ isDark?: boolean, isGameDeziiign?: boolean }>`
  ${({ isDark }) => isDark &&
        css`
    .dropdown-show {
        .dropdown-list-item {
            background: ${(isGameDeziiign) => isGameDeziiign ? '#3f4548 !important' : '#3F4548 !important'};
            & div {
                color: #ABAEAF !important;
            }
            .active {
                color: #FFF !important;
                svg path {
                    fill: #fefefe !important;
                }
            }
            &:hover {
                background: #575B5E !important;
                & div {
                    color: #ABAEAF !important;
                    background: none;
                }
                svg {
                    background: inherit;
                }
                .active {
                    color: #FFF !important;
                    svg path {
                        fill: #FEFEFE !important;
                    }
                }
            }
        }
    }        
    `
    }
`

export const ProjectSearchBarSorting: FC<{
    selectedSorting?: SortingTypeIndex | SortingTypeIndexPeople;
    onSortingChange?: (sorting: any) => void;
    sortingMethods?: SortingTypeIndex[] | SortingTypeIndexPeople[];
    isPeoplePage?: boolean;
    isDarkTheme?: boolean;
    isCompetitions?: boolean;
}> = (props) => {
    const { onSortingChange, sortingMethods, isPeoplePage, isDarkTheme, isCompetitions } = props;
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();
    const sm: number[] = sortingMethods ?? [1, 2, 26];
    const isDafes = AppTester.isGeoDafes();
    const isDesignContext = (getCurrentAppName() !== 'competition' && getCurrentAppName() !== 'deziiign' && !isDafes) || isDarkTheme;
    const isSuperPuper = AppTester.isSuperPuper();
    const isGameDeziiign = AppTester.isGameDeziiign();

    const showShop = AppTester.isGalllleryArt() || AppTester.isDeziiignMain() || AppTester.isHSEDesign() ||
        AppTester.isAcademy() || AppTester.isMediiia() || AppTester.isGeoDafes() || AppTester.isProDeziiign() || AppTester.isKiiidsArt();

    const isLMSOffline = !!useRouteMatch('/courses_offline');
    const is992 = useBreakpoint(LayoutConst.screen.m);

    const selectedSorting = Number(props.selectedSorting);

    const sortingItems = useMemo(() => {
        const items: Record<number, { label: string; value: SortingTypeIndex; hidden?: boolean }> = {
            [SortingTypeIndex.price_inc]: {
                label: t('filter.price_inc'),
                value: SortingTypeIndex.price_inc,
            },
            [SortingTypeIndex.price_dec]: {
                label: t('filter.price_dec'),
                value: SortingTypeIndex.price_dec,
            },
            [SortingTypeIndex.moderation]: {
                label: isCompetitions ? t('sorting_type.current_competition') : t('filter.moderation' + (is992 ? '_nom' : '')),
                value: SortingTypeIndex.moderation,
            },
            [SortingTypeIndex.popular]: {
                label: t('filter.popular' + (is992 ? '_nom' : '')),
                value: SortingTypeIndex.popular,
            },
            [SortingTypeIndex.PersonPopular]: {
                label: t('filter.rating'),
                value: SortingTypeIndex.PersonPopular,
            },
            [SortingTypeIndex.course_start]: {
                label: isLMSOffline ? t('filter.course_start') : t('filter.name'),
                value: SortingTypeIndex.course_start,
            },
            [SortingTypeIndex.name]: {
                label: t('filter.name'),
                value: SortingTypeIndex.name,
            },
            [SortingTypeIndex.projects]: {
                label: isPeoplePage ? t('filter.opa') : t('filter.project'),
                value: SortingTypeIndex.projects,
            },
            [SortingTypeIndex.opa]: {
                label: t('filter.opa'),
                value: SortingTypeIndex.opa,
            },
            [SortingTypeIndex.score]: {
                label: t('filter.score'),
                value: SortingTypeIndex.score,
            },
            [SortingTypeIndex.relevant]: {
                label: t('filter.relevant' + (is992 ? '_nom' : '')),
                value: SortingTypeIndex.relevant,
            },
            [SortingTypeIndex.shop]: {
                label: t('filter.shop'),
                value: SortingTypeIndex.shop,
                hidden: !showShop,
            },
            [SortingTypeIndex.mediiia_all]: {
                label: t('filter.mediiia_all'),
                value: SortingTypeIndex.mediiia_all,
            },
            [SortingTypeIndex.mediiia_author]: {
                label: t('filter.mediiia_author'),
                value: SortingTypeIndex.mediiia_author,
            },
            [SortingTypeIndex.mediiia_education]: {
                label: t('filter.mediiia_education'),
                value: SortingTypeIndex.mediiia_education,
            },
        };
        return items;
    }, [isCompetitions, isPeoplePage, is992, showShop, language, isLMSOffline, t])

    const list = useMemo(() => {
        return sm.reduce((acc: any, item: any) => {
            if (item in sortingItems) {
                const { label, value, hidden } = sortingItems[item];
                if (hidden) return acc;
                acc.push(<DropdownListItem key={value} onClick={() => props.onSortingChange?.(value)}>
                    <FlexBox justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                        <DropdownText isActive={selectedSorting === value}>
                            {label}
                        </DropdownText>
                        <ApprovedIcon fill={theme.tags.textColor} display={selectedSorting === value} />
                    </FlexBox>
                </DropdownListItem>)
            }
            return acc
        }, [])
    }, [sm, selectedSorting, onSortingChange, theme, sortingItems])

    return (
        <ProjectSearchBarRoot align={'center'}>
            <SortSmallTextDiv style={{ whiteSpace: 'pre' }} color={theme.sortByColor}>{is992 ? <SortIcon /> : t('sort_by')}</SortSmallTextDiv>
            <DropDownWrapper isDark={props.isDarkTheme} isGameDeziiign={isGameDeziiign}>
                <Dropdown
                    dark={isDesignContext || isSuperPuper}
                    offsetArrowX={38}
                    // offsetX={-60}
                    hideArrow
                    orientation='right'
                    target={
                        <HoverItemWithSvg color={theme.sortByColorSort} gx={8}>
                            <HoverItemText>{sortingItems[selectedSorting]?.label}</HoverItemText>
                            <FInter.SmallText style={{ alignItems: 'center', display: 'flex' }}>
                                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                                        fill={theme.tags.textColor} />
                                </svg>
                            </FInter.SmallText>
                        </HoverItemWithSvg>
                    }
                >
                    {list}
                </Dropdown>
            </DropDownWrapper>
        </ProjectSearchBarRoot>
    );
};
import { FC, useMemo } from 'react';
import { Dropdown, DropdownListItem, FInter, FlexBox, useBreakpoint } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { SortingTypeIndex } from '../../../constants/sortingType';
import { HoverItemText, HoverItemWithSvg, ProjectSearchBarRoot, SortSmallTextDiv } from '../style';
import styled, { css, useTheme } from 'styled-components';
import { AppTester, getCurrentAppName } from '../../../../supporting';
import { DropdownText } from 'shared/navbars/components/contextTabsItems';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { LayoutConst } from "../../../../core";
import { SortingTypeIndexPeople } from "../../../pages/context/contextViewClear";
import { SortIcon } from 'shared/icons';
import { useRouteMatch } from 'react-router-dom';

const DropDownWrapper = styled(FlexBox) <{ isDark?: boolean, isGameDeziiign?: boolean }>`
  ${({ isDark }) => isDark &&
        css`
    .dropdown-show {
        .dropdown-list-item {
            background: ${(isGameDeziiign) => isGameDeziiign ? '#3f4548 !important' : '#3F4548 !important'};
            & div {
                color: #ABAEAF !important;
            }
            .active {
                color: #FFF !important;
                svg path {
                    fill: #fefefe !important;
                }
            }
            &:hover {
                background: #575B5E !important;
                & div {
                    color: #ABAEAF !important;
                    background: none;
                }
                svg {
                    background: inherit;
                }
                .active {
                    color: #FFF !important;
                    svg path {
                        fill: #FEFEFE !important;
                    }
                }
            }
        }
    }        
    `
    }
`

export const ProjectSearchBarSorting: FC<{
    selectedSorting?: SortingTypeIndex | SortingTypeIndexPeople;
    onSortingChange?: (sorting: any) => void;
    sortingMethods?: SortingTypeIndex[] | SortingTypeIndexPeople[];
    isPeoplePage?: boolean;
    isDarkTheme?: boolean;
    isCompetitions?: boolean;
}> = (props) => {
    const { onSortingChange, sortingMethods, isPeoplePage, isDarkTheme, isCompetitions } = props;
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();
    const sm: number[] = sortingMethods ?? [1, 2, 26];
    const isDafes = AppTester.isGeoDafes();
    const isDesignContext = (getCurrentAppName() !== 'competition' && getCurrentAppName() !== 'deziiign' && !isDafes) || isDarkTheme;
    const isSuperPuper = AppTester.isSuperPuper();
    const isGameDeziiign = AppTester.isGameDeziiign();

    const showShop = AppTester.isGalllleryArt() || AppTester.isDeziiignMain() || AppTester.isHSEDesign() ||
        AppTester.isAcademy() || AppTester.isMediiia() || AppTester.isGeoDafes() || AppTester.isProDeziiign() || AppTester.isKiiidsArt();

    const isLMSOffline = !!useRouteMatch('/courses_offline');
    const is992 = useBreakpoint(LayoutConst.screen.m);

    const selectedSorting = Number(props.selectedSorting);

    const sortingItems = useMemo(() => {
        const items: Record<number, { label: string; value: SortingTypeIndex; hidden?: boolean }> = {
            [SortingTypeIndex.price_inc]: {
                label: t('filter.price_inc'),
                value: SortingTypeIndex.price_inc,
            },
            [SortingTypeIndex.price_dec]: {
                label: t('filter.price_dec'),
                value: SortingTypeIndex.price_dec,
            },
            [SortingTypeIndex.moderation]: {
                label: isCompetitions ? t('sorting_type.current_competition') : t('filter.moderation' + (is992 ? '_nom' : '')),
                value: SortingTypeIndex.moderation,
            },
            [SortingTypeIndex.popular]: {
                label: t('filter.popular' + (is992 ? '_nom' : '')),
                value: SortingTypeIndex.popular,
            },
            [SortingTypeIndex.PersonPopular]: {
                label: t('filter.rating'),
                value: SortingTypeIndex.PersonPopular,
            },
            [SortingTypeIndex.course_start]: {
                label: isLMSOffline ? t('filter.course_start') : t('filter.name'),
                value: SortingTypeIndex.course_start,
            },
            [SortingTypeIndex.name]: {
                label: t('filter.name'),
                value: SortingTypeIndex.name,
            },
            [SortingTypeIndex.projects]: {
                label: isPeoplePage ? t('filter.opa') : t('filter.project'),
                value: SortingTypeIndex.projects,
            },
            [SortingTypeIndex.opa]: {
                label: t('filter.opa'),
                value: SortingTypeIndex.opa,
            },
            [SortingTypeIndex.score]: {
                label: t('filter.score'),
                value: SortingTypeIndex.score,
            },
            [SortingTypeIndex.relevant]: {
                label: t('filter.relevant' + (is992 ? '_nom' : '')),
                value: SortingTypeIndex.relevant,
            },
            [SortingTypeIndex.shop]: {
                label: t('filter.shop'),
                value: SortingTypeIndex.shop,
                hidden: !showShop,
            },
            [SortingTypeIndex.mediiia_all]: {
                label: t('filter.mediiia_all'),
                value: SortingTypeIndex.mediiia_all,
            },
            [SortingTypeIndex.mediiia_author]: {
                label: t('filter.mediiia_author'),
                value: SortingTypeIndex.mediiia_author,
            },
            [SortingTypeIndex.mediiia_education]: {
                label: t('filter.mediiia_education'),
                value: SortingTypeIndex.mediiia_education,
            },
        };
        return items;
    }, [isCompetitions, isPeoplePage, is992, showShop, language, isLMSOffline, t])

    const list = useMemo(() => {
        return sm.reduce((acc: any, item: any) => {
            if (item in sortingItems) {
                const { label, value, hidden } = sortingItems[item];
                if (hidden) return acc;
                acc.push(<DropdownListItem key={value} onClick={() => props.onSortingChange?.(value)}>
                    <FlexBox justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                        <DropdownText isActive={selectedSorting === value}>
                            {label}
                        </DropdownText>
                        <ApprovedIcon fill={theme.tags.textColor} display={selectedSorting === value} />
                    </FlexBox>
                </DropdownListItem>)
            }
            return acc
        }, [])
    }, [sm, selectedSorting, onSortingChange, theme, sortingItems])

    return (
        <ProjectSearchBarRoot align={'center'}>
            <SortSmallTextDiv style={{ whiteSpace: 'pre' }} color={theme.sortByColor}>{is992 ? <SortIcon /> : t('sort_by')}</SortSmallTextDiv>
            <DropDownWrapper isDark={props.isDarkTheme} isGameDeziiign={isGameDeziiign}>
                <Dropdown
                    dark={isDesignContext || isSuperPuper}
                    offsetArrowX={38}
                    // offsetX={-60}
                    hideArrow
                    orientation='right'
                    target={
                        <HoverItemWithSvg color={theme.sortByColorSort} gx={8}>
                            <HoverItemText>{sortingItems[selectedSorting]?.label}</HoverItemText>
                            <FInter.SmallText style={{ alignItems: 'center', display: 'flex' }}>
                                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                                        fill={theme.tags.textColor} />
                                </svg>
                            </FInter.SmallText>
                        </HoverItemWithSvg>
                    }
                >
                    {list}
                </Dropdown>
            </DropDownWrapper>
        </ProjectSearchBarRoot>
    );
};
